import { useCallback } from 'react'
import { useScrollToNewContentSelector } from '../ScrollToNewContentStore'

/**
 * Hook for marking content as newly created and triggering scroll-into-content action
 * @returns markAsNewlyCreated - function that marks the content as newly created and scrolls to it
 * */
export const useNewContentCreation = () => {
    const {
        addTemporaryContent,
        scrollToContent,
    } = useScrollToNewContentSelector((state) => ({
        addTemporaryContent: state.addTemporaryContent,
        scrollToContent: state.scrollToContent,
    }))

    const markAsNewlyCreated = useCallback(
        (contentId?: string) => {
            if (!contentId) return

            addTemporaryContent(contentId)
            scrollToContent(contentId)
        },
        [addTemporaryContent, scrollToContent]
    )

    return { markAsNewlyCreated }
}
